import React, { createContext, useContext, useState } from 'react';
import { getTimezoneEnumFromBrowser } from '../ai/enums';

const TimezoneContext = createContext();

export const useTimezone = () => {
    const context = useContext(TimezoneContext);
    if (!context) {
        throw new Error('useTimezone must be used within a TimezoneProvider');
    }
    return context;
};

export const TimezoneProvider = ({ children }) => {
    const [timezone, setTimezone] = useState(() => {
        // Initialize with actual timezone immediately to prevent null state
        try {
            return getTimezoneEnumFromBrowser();
        } catch (error) {
            console.error('Failed to detect timezone on initialization:', error);
            return 480; // Fallback to LOS_ANGELES timezone enum value
        }
    });
    const value = {
        timezone,
        refreshTimezone: () => {
            try {
                const newTimezone = getTimezoneEnumFromBrowser();
                setTimezone(newTimezone);
                return newTimezone;
            } catch (error) {
                console.error('Failed to refresh timezone:', error);
                return timezone; // Return current timezone on error
            }
        }
    };

    return (
        <TimezoneContext.Provider value={value}>
            {children}
        </TimezoneContext.Provider>
    );
};